import React, { useState } from 'react';
import { ContentCard } from '../common/ContentCard';
import { OrderDetailsModal } from '../common/OrderDetailsModal';
import { BookingJobCard } from './BookingJobCard';
import type { RouteJob } from '../../types/deliveryManagement';

interface BookingJobsListProps {
  jobs: RouteJob[];
  isLoading: boolean;
  isError: boolean;
  error?: any;
  isLoaded: boolean;
}

export const BookingJobsList: React.FC<BookingJobsListProps> = ({
  jobs,
  isLoading,
  isError,
  error,
  isLoaded,
}) => {
  const [viewOrdersModal, setViewOrdersModal] = useState<{ jobId: string; customerName: string } | null>(null);

  return (
    <>
      <ContentCard>
        {!isLoaded ? (
          <div className="p-6 text-center text-gray-500">
            <p>Select a date and engineer, then click "Load Routes" to view bookings.</p>
          </div>
        ) : isError ? (
          <div className="p-6 text-center text-red-600">
            <p className="font-semibold mb-2">Error Loading Booking Details</p>
            <p className="text-sm">{(error as any)?.data?.detail || 'Failed to fetch delivery jobs'}</p>
            <p className="text-xs text-gray-500 mt-2">Check browser console for details</p>
          </div>
        ) : isLoading ? (
          <div className="p-6 text-center text-gray-500">
            <p>Loading booking details...</p>
          </div>
        ) : jobs.length === 0 ? (
          <div className="p-6 text-center text-gray-500">
            <p>No bookings found for the selected date and engineer.</p>
            <p className="text-xs mt-2">Try selecting a different date or engineer.</p>
          </div>
        ) : (
          <div className="space-y-4">
            {jobs.map((job, index) => (
              <BookingJobCard
                key={job.id}
                job={job}
                index={index}
                onViewOrders={(jobId, customerName) => setViewOrdersModal({ jobId, customerName })}
              />
            ))}
          </div>
        )}
      </ContentCard>

      {/* View Orders Modal */}
      {viewOrdersModal && (
        <OrderDetailsModal
          isOpen={true}
          onClose={() => setViewOrdersModal(null)}
          jobId={viewOrdersModal.jobId}
          title={`Orders - ${viewOrdersModal.customerName}`}
          mode="view"
        />
      )}
    </>
  );
};

BookingJobsList.displayName = 'BookingJobsList';
